import React from 'react';
import { useDocumentsList } from '../hooks/use-documents-list.js';
import DocumentsPageView from './documents-page-view.jsx';

function DocumentsPageContainer() {
  const state = useDocumentsList();
  return <DocumentsPageView {...state} />;
}

export default DocumentsPageContainer;

